import { DEFAULT_SKIN_ID, isSkinId } from "./registry";
import { SkinId } from "./types";

export const SKIN_QUERY_PARAM = "skin";
export const SKIN_STORAGE_KEY = "appSkin";

interface RuntimeSkinSource {
  search?: string;
  storage?: Pick<Storage, "getItem" | "setItem"> | null;
}

const getQuerySkin = (search: string): string | null => {
  const params = new URLSearchParams(search);
  return params.get(SKIN_QUERY_PARAM) || params.get(SKIN_STORAGE_KEY);
};

export const resolveRuntimeSkinId = ({
  search = "",
  storage,
}: RuntimeSkinSource): SkinId => {
  const querySkin = getQuerySkin(search);
  if (isSkinId(querySkin)) {
    try {
      storage?.setItem(SKIN_STORAGE_KEY, querySkin);
    } catch (_error) {
      // Skin switching should never block app bootstrap.
    }
    return querySkin;
  }

  try {
    const storedSkin = storage?.getItem(SKIN_STORAGE_KEY);
    if (isSkinId(storedSkin)) {
      return storedSkin;
    }
  } catch (_error) {
    // Ignore unavailable storage in restricted browser contexts.
  }

  return DEFAULT_SKIN_ID;
};

export const getInitialSkinId = (): SkinId => {
  if (typeof window === "undefined") {
    return DEFAULT_SKIN_ID;
  }

  let storage: Pick<Storage, "getItem" | "setItem"> | null = null;
  try {
    storage = window.localStorage;
  } catch (_error) {
    storage = null;
  }

  return resolveRuntimeSkinId({
    search: window.location.search,
    storage,
  });
};
